import React, { useEffect, useState } from 'react';


const GroupedPassengerIcon = ({ job }) => {

    const [type, setType] = useState('Boarding');
    const [tooltipContent, setTooltipContent] = useState('');

    useEffect(() => {
        // check if boarding task
        if (job?.combinedBooking) {
            if (job?.passengers?.length > 1) {
                if (job?.combinedMarshallBooking) {
                    setType('Marshall (' + job?.passengers?.length + ' Pax)')
                    setTooltipContent('Marshall (' + job?.passengers?.length + ' Pax)')
                }
                else {
                    setType('Boarding (' + job?.passengers?.length + ' Pax)')
                    setTooltipContent('Boarding Task (' + job?.passengers?.length + ' Pax)')
                }
            }
            else {
                if (job?.combinedMarshallBooking) {
                    setType('Marshall')
                    setTooltipContent('Marshall')
                }
                else {
                    setType('Boarding (1 Pax)')
                    setTooltipContent('Boarding Task (1 Pax)')
                }
            }
        }

        // check if grouped task
        if (job?.groupedBooking || job?.buggyTask) {
            if (job?.passengers?.length > 1) {
                setType(`Grouped (${job?.passengers?.length} Pax)`)
                setTooltipContent(`Grouped Task with (${job?.passengers?.length} Pax)`)
            }
            else {
                setType('Grouped (1 Pax)')
                setTooltipContent('Grouped Task (1 Pax)')
            }
        }

        // check if ramp booking
        if (job?.combinedRampBooking) {
            if (job?.passengers?.length > 1) {
                if (job?.combinedMarshallBooking) {
                    setType('Marshall (' + job?.passengers?.length + ' Pax)')
                    setTooltipContent('Marshall (' + job?.passengers?.length + ' Pax)')
                }
                else {
                    setType('Ramp (' + job?.passengers?.length + ' Pax)')
                    setTooltipContent('Ramp Task (' + job?.passengers?.length + ' Pax)')
                }
            }
            else {
                if (job?.combinedMarshallBooking) {
                    setType('Marshall')
                    setTooltipContent('Marshall')
                }
                else {
                    setType('Ramp (1 Pax)')
                    setTooltipContent('Ramp Task (1 Pax)')
                }
            }
        }

        // check if flight task
        if (job?.flightTask) {
            if (job?.passengers?.length > 1) {
                setType(`Flight (${job?.passengers?.length} Pax)`)
                setTooltipContent(`Flight Task with (${job?.passengers?.length} Pax)`)
            }
            else {
                setType('Flight (1 Pax)')
                setTooltipContent('Flight Task (1 Pax)')
            }
        }


    }, [job]);

    return (
        <p style={{ margin: "0px 0", fontSize: 10, fontWeight: "500" }} {...(tooltipContent !== "" ? { 'data-tippy-content': tooltipContent } : {})}>
            {type}
        </p>
    )
};

export default GroupedPassengerIcon;
